import { apiClient } from './api'
import { ENDPOINTS } from '@/config/api.config'
import type { Module, Episode } from '@/types'

export const modulesService = {
  /**
   * Get all modules with episodes
   */
  getAll: async (): Promise<Module[]> => {
    return apiClient.get<Module[]>(ENDPOINTS.modules.list)
  },

  /**
   * Get module by ID
   */
  getById: async (id: number): Promise<Module> => {
    return apiClient.get<Module>(ENDPOINTS.modules.byId(id))
  },

  /**
   * Get episode details
   */
  getEpisode: async (moduleId: number, episodeId: number): Promise<Episode> => {
    return apiClient.get<Episode>(ENDPOINTS.episodes.byId(moduleId, episodeId))
  },
}
